import { OnInit } from '@angular/core';
var UserIconListComponent = /** @class */ (function () {
    function UserIconListComponent() {
    }
    UserIconListComponent.prototype.ngOnInit = function () {
    };
    UserIconListComponent.prototype.ngOnChanges = function () {
    };
    return UserIconListComponent;
}());
export { UserIconListComponent };
